/* eslint-disable no-unused-expressions */
import React, { Component } from 'react'
import { history } from '../helper/history'
import localdata from '../helper/localdata'
import swal from 'sweetalert'
import { NavLink } from 'react-router-dom'
import request from 'superagent'
import apis from '../helper/api'
import moment from 'moment'
import action from '../helper/action'
import do_action from '../action'
import { connect } from 'react-redux'
import config from '../helper/config'
import util from '../helper/util'
import Modal from 'react-responsive-modal'
import ReactGA from 'react-ga'
import cookie from 'react-cookies'
import PospayLogo from '../layout/metronic/pospay-logo-color.svg'

class AgentUserName extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name_of_user: '',
    }
    this.on_ok = this.on_ok.bind(this)
    this.on_key_press = this.on_key_press.bind(this)
  }

  on_input_change(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  on_key_press(e) {
    if (e.keyCode === 13) {
      if (e.target.name === 'name_of_user') {
        this.on_ok()
      }
    }
  }

  on_ok() {
    if (this.state.name_of_user.length !== 0) {
      const expires = new Date()
      expires.setDate(expires.getDate() + 9999)
      cookie.save('name_agent', this.state.name_of_user, { path: '/', expires, secure: false, httpOnly: false, domain: window.location.hostname })
      this.props.data.on_close()
    }
  }

  render() {
    let data = this.props.data
    return (
      <Modal
        className="modal"
        open={true}
        onClose={data.on_close}
        center
        showCloseIcon={false}
        closeOnOverlayClick={false}
      >
        <div
          className="modal-dialog modal-lg"
          role="document"
          style={{ marginTop: 0 + 'px', marginBottom: 0 + 'px', width: '500px' }}
        >
          <div
            className="modal-content"
            style={{ border: 'white' }}
          >
            <div className="modal-header">
              <h5 className="modal-title">Hi Agen POSFIN</h5>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <span style={{ marginBottom: '15px', display: 'block' }}>Kami membutuhkan nama anda sebagai Agen POSFIN agar semua proses transaksi semakin lancar :)</span>
                  <div className="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                    <div className="m-portlet__body">
                      <input
                        onChange={(e) => this.on_input_change(e)}
                        onKeyDown={this.on_key_press}
                        type="text"
                        className="form-control m-input"
                        name="name_of_user"
                        value={this.state.name_of_user}
                        placeholder="Isi nama anda disini"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                onClick={this.on_ok}
                className="btn btn-secondary btn-sm m-btn m-btn--custom"
                data-dismiss="modal"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

class SMSToken extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sms_token: '',
      seconds: '00',
      minutes: '00',
      disable_resend_btn: true,
      flag_processing: false,
    }
    this.secondsRemaining
    this.intervalHandle
    this.handleChange = this.handleChange.bind(this)
    this.startCountDown = this.startCountDown.bind(this)
    this.tick = this.tick.bind(this)
    this.on_submit = this.on_submit.bind(this)
    this.on_resend_token = this.on_resend_token.bind(this)
    this.on_key_press = this.on_key_press.bind(this)
  }

  componentDidMount() {
    let self = this
    this.startCountDown()
  }

  componentWillUnmount() {
    clearInterval(this.intervalHandle)
  }

  handleChange(event) {
    this.setState({ minutes: event.target.value })
  }

  tick() {
    var min = Math.floor(this.secondsRemaining / 60)
    var sec = this.secondsRemaining - min * 60
    this.setState({
      minutes: min,
      seconds: sec,
    })
    if (sec < 10) {
      this.setState({ seconds: '0' + this.state.seconds })
    }
    if (min < 10) {
      this.setState({ minutes: '0' + min })
    }
    if ((min === 0) & (sec === 0)) {
      this.setState({ disable_resend_btn: false })
      clearInterval(this.intervalHandle)
    }
    this.secondsRemaining--
  }

  startCountDown() {
    this.setState({ seconds: '00', minutes: '02' })
    this.secondsRemaining = 120
    this.intervalHandle = setInterval(this.tick, 1000)
  }

  on_input_change(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  on_key_press(e) {
    if (e.keyCode === 13) {
      if (e.target.name === 'sms_token') {
        this.on_submit()
      }
    }
  }

  on_submit() {
    if (this.state.sms_token.length === 0) return
    let self = this
    let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()
    let body = {
      white_label_id: whitelabel_36,
      username: this.props.data.username,
      token_sms: this.state.sms_token,
    }
    this.setState({ flag_processing: true })

    // !! SMS TOKEN SUMBIT
    request
      .post(apis.sms_token_submit)
      .set('Content-Type', 'application/json')
      .send(body)
      .end(function (err, res) {
        let message_result = ''
        if (err || !res.ok) {
          util.log(err)
          message_result = { title: 'Error', body: err.message }
          if (res !== undefined) {
            message_result.body = 'Error code ' + res.statusCode
          }
        } else {
          util.log(res)
          if (res.statusCode === 200) {
            let payload = res.body
            if (payload.status === 'OK') {
              message_result = { title: 'Sukses', body: 'Token telah dikirimkan' }
              if (payload.display_message !== undefined) {
                message_result = { title: payload.error.message, body: payload.display_message }
              }
              self.props.data.on_close()
            } else {
              message_result = { title: 'Error', body: payload.error.message }
              if (payload.display_message !== undefined) {
                message_result = { title: payload.error.message, body: payload.display_message }
              }
            }
          } else {
            message_result = { title: 'Error', body: res.statusCode }
          }
          if (message_result.length !== 0) {
            swal(message_result.title, message_result.body, 'warning')
          }
        }
        self.setState({ flag_processing: false })
      })
  }

  async on_resend_token() {
    let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()
    // let machine_id = await util.get_uuid();
    let machine_id = await util.initFingerPrint()

    let body = {
      white_label_id: whitelabel_36,
      username: this.props.data.username,
      device_id: machine_id + ';fingerprintJS',
      platform: util.get_platform(),
    }
    this.setState({ disable_resend_btn: true })
    this.startCountDown()
    request
      .post(apis.sms_token_resend)
      .set('Content-Type', 'application/json')
      .send(body)
      .end(function (err, res) {
        let message_result = ''
        if (err || !res.ok) {
          util.log(err)
          message_result = { title: 'Error', body: err.message }
          if (res !== undefined) {
            message_result.body = 'Error code ' + res.statusCode
          }
        } else {
          util.log(res)
          if (res.statusCode === 200) {
            let payload = res.body
            if (payload.status === 'OK') {
              message_result = { title: 'Sukses', body: 'Token telah dikirimkan' }
              if (payload.display_message !== undefined) {
                message_result = { title: payload.error.message, body: payload.display_message }
              }
            } else {
              message_result = { title: 'Error', body: payload.error.message }
              if (payload.display_message !== undefined) {
                message_result = { title: payload.error.message, body: payload.display_message }
              }
            }
          } else {
            message_result = { title: 'Error', body: res.statusCode }
          }
          if (message_result.length !== 0) {
            swal(message_result.title, message_result.body, 'warning')
          }
        }
      })
  }

  render() {
    let data = this.props.data
    return (
      <Modal
        className="modal"
        open={true}
        center
        onClose={data.on_close}
        showCloseIcon={true}
        closeOnOverlayClick={false}
      >
        <div
          className="modal-dialog modal-lg"
          role="document"
          style={{ marginTop: 0 + 'px', marginBottom: 0 + 'px', width: '500px' }}
        >
          <div
            className="modal-content"
            style={{ border: 'white' }}
          >
            <div className="modal-header">
              <h5 className="modal-title">Masukkan SMS Token</h5>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <span style={{ marginBottom: '15px', display: 'block' }}>{data.message}</span>
                  <div className="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                    <div className="m-portlet__body">
                      <input
                        onChange={(e) => this.on_input_change(e)}
                        onKeyDown={this.on_key_press}
                        type="text"
                        className="form-control m-input"
                        name="sms_token"
                        value={this.state.sms_token}
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                onClick={this.on_submit}
                className={this.state.flag_processing ? 'btn btn-secondary btn-sm m-btn m-btn--custom m-loader m-loader--primary m-loader--right' : 'btn btn-secondary btn-sm m-btn m-btn--custom'}
                data-dismiss="modal"
              >
                Submit
              </button>
              <button
                disabled={this.state.disable_resend_btn}
                type="button"
                onClick={this.on_resend_token}
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Kirim Lagi Token ({this.state.minutes} : {this.state.seconds})
              </button>
              <button
                style={{ display: 'none' }}
                type="button"
                onClick={data.on_close}
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

class Login extends Component {
  constructor(props) {
    super(props)
    ReactGA.initialize(config.ga.prop)
    this.state = {
      login_btn: true,
      username: '',
      password: '',
      operator: '',
      captha: '',
      captha_img: apis.get_captha + '?' + moment(),
      type_input_password: 'password',
      show_sms_token: false,
      message_sms_token: 'SMS Token telah dikirimkan ke nomer Anda',
      show_name_of_user: false,
      name_of_user: '',
      remember: true,
      login_as: 'operator',
    }
    this.login = this.login.bind(this)
    this.on_key_press = this.on_key_press.bind(this)
    this.on_checkbox_change = this.on_checkbox_change.bind(this)
  }

  componentDidMount() {
    let self = this
    ReactGA.pageview('/login')
    if (util.is_electron()) {
      window.ipcRenderer.on('rpc-response', (event, res) => {
        util.log('[login] rpc-response', res)
        if (res.method === 'get_db') {
          if (res.return) {
            const saved = res.return
            let saved_state = {}
            for (let i = 0; i < saved.length; i++) {
              let item = saved[i]
              if (item._id === 'remember_password') {
                var decoded_password = ''
                try {
                  decoded_password = window.atob(item.val)
                } catch (err) {
                  util.log(err)
                }
                if (decoded_password.includes('~~~')) {
                  let t = decoded_password.split('~~~')
                  saved_state.username = t[0]
                  saved_state.password = t[1]
                  if (self.captha_input !== null) {
                    self.captha_input.focus()
                  }
                }
              }
            }
            if (Object.keys(saved_state).length !== 0) {
              self.setState(saved_state)
            }
          }
        }
      })
    }
    let remember_password = ''
    if (util.is_electron()) {
      let request = { method: 'get_db', params: {} }
      util.log('rpc-request', request)
      window.ipcRenderer.send('rpc-request', request)
    } else {
      remember_password = cookie.load('remember_password')
    }
    if (remember_password !== undefined && remember_password.length !== 0) {
      var decoded_password = ''
      try {
        decoded_password = window.atob(remember_password)
      } catch (err) {
        util.log(err)
      }
      if (decoded_password.includes('~~~')) {
        let t = decoded_password.split('~~~')
        this.setState({ username: t[0], password: t[1] })
        this.captha_input.focus()
      }
    }
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  remember() {
    if (this.state.remember) {
      const username_password = this.state.username + '~~~' + this.state.password
      var saved = window.btoa(username_password)
      try {
        if (util.is_electron()) {
          let d = { list: [{ key: 'remember_password', value: saved }] }
          let request = { method: 'save_db', params: d }
          util.log('rpc-request', request)
          window.ipcRenderer.send('rpc-request', request)
        } else {
          const expires = new Date()
          expires.setDate(expires.getDate() + 9999)
          cookie.save('remember_password', saved, { path: '/', expires, secure: false, httpOnly: false, domain: window.location.hostname })
        }
      } catch (err) {
        util.log(err)
      }
    } else {
      if (util.is_electron()) {
        let request = { method: 'delete_db', params: { search: { _id: 'remember_password' } } }
        util.log('rpc-request', request)
        window.ipcRenderer.send('rpc-request', request)
      } else {
        cookie.remove('remember_password', { path: '/' })
        cookie.remove('remember_password', { path: '/', domain: 'fintechagent-stg.bedigital.co.id' })
        cookie.remove('remember_password', { path: '/', domain: 'agen.posfin.id' })
      }
    }
  }

  async login() {
    //  let uuidnya = await util.initFingerPrint();
    // util.log("machine_id ="+uuidnya);
    if (this.state.username === '' || this.state.password === '' || this.state.captha === '') {
      return swal('Ups !', 'Data yang kamu berikan belum valid ', 'warning')
      // return swal("Ups !", "Data yang kamu berikan belum valid "+uuidnya, "warning");
    }

    // if (this.state.username.startsWith("0")) {
    //     return swal("Format Salah", "Gunakan format internasional untuk nomor Telepon anda (nomor Indonesia gunakan awalan \"62\")", "warning");
    // }

    let agent_name_device = ''
    if (util.is_electron()) {
      agent_name_device = await util.electron_get_username()
    }

    if (agent_name_device === undefined || agent_name_device.length === 0) {
      // agent_name_device = cookie.load('name_agent');
      // if (agent_name_device === undefined) {
      //     this.setState({show_name_of_user: true});
      //     return;
      // }
    }

    util.log('agent_name_device', agent_name_device)
    let u = this.state.username
    if (this.state.login_as !== 'operator') {
      if (this.state.operator.length === 0) {
        swal('Ups !', 'Kode operator tidak valid', 'error')
        return
      }
      u = this.state.username + '#' + this.state.operator
    }

    let data = {
      username: u.toUpperCase(),
      password: this.state.password,
      captha: this.state.captha,
    }

    let self = this
    let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()
    let deviceidopt = ''
    let deviceidplatform = ''
    // let machine_id = await util.get_uuid();
    let machine_id = await util.initFingerPrint()
    // util.log("machine_id ="+machine_id);
    if (util.is_electron()) {
      deviceidopt = machine_id
      deviceidplatform = 'DESKTOP'
    } else {
      deviceidopt = machine_id + ';fingerprintJS'
      deviceidplatform = 'WEB'
    }
    let mac_address = ''
    let body_1 = {
      white_label_id: whitelabel_36,
      captcha: data.captha,
      device_id: deviceidopt,
      language: 'id',
      platform: deviceidplatform,
      app_version: '1.12',
    }
    if (agent_name_device.length !== 0) {
      body_1.device_name = agent_name_device
    }
    if (util.is_electron()) {
      if (machine_id == null || machine_id.length === 0) {
        swal('Error', 'Validasi device id sedang berlangsung, tunggu beberapa saat lagi dan coba untuk login ulang.', 'error')
        return
      }
      var user_agent = navigator.userAgent
      mac_address = user_agent.split('/').pop()
      if (mac_address.endsWith(';')) {
        mac_address = mac_address.substring(0, mac_address.length - 1)
      }
      body_1.mac_address = mac_address
    }
    util.log(body_1)
    self.setState({ login_btn: false })
    request
      .post(apis.login)
      .set('Content-Type', 'application/json')
      .send(body_1)
      .end(function (err, res) {
        if (err || !res.ok) {
          util.log(err)
          if (res !== undefined && res.statusCode === 401) {
            util.log(res)
            if (res.headers) {
              let www_auth = res.headers['www-authenticate']
              let www_auth_obj = util.parse_www_auth(www_auth)
              util.log(www_auth_obj)

              let realm = www_auth_obj.realm
              let nonce = www_auth_obj.nonce
              let opaque = www_auth_obj.opaque
              let uri = '/api/' + apis.version + '/agent/auth/login'
              let postfix_username = data.username.substr(data.username.length - 3)

              if (self.state.login_as !== 'operator') {
                if (postfix_username.includes('#')) {
                  let user_split = postfix_username.split('#')
                  postfix_username = user_split[1]
                }
              }

              util.log('postfix_username', postfix_username)
              let pass = whitelabel_36.substring(whitelabel_36.length - 3) + data.password.toString(36) + postfix_username
              let password_encode = util.md5(pass)
              let A1 = util.md5(data.username + ':' + realm + ':' + password_encode)
              let A2 = util.md5('POST' + ':' + uri)
              let response = util.md5(A1 + ':' + nonce + ':' + A2)

              // util.log("plain pass: " + pass + "\nencode pass: " + password_encode)
              // util.log("realm: "+ realm +"\nnonce: " +nonce+ "\nopaque: " + opaque + "\nA1: " + A1 + "\nA2: " + A2 + "\nResponse: " + response)

              let body_2 = {
                white_label_id: whitelabel_36,
                captcha: data.captha,
                platform: util.get_platform(),
                device_id: deviceidopt,
                language: 'id',
                platform: deviceidplatform,
                app_version: '1.12',
              }

              if (agent_name_device.length !== 0) {
                body_2.device_name = agent_name_device
              }

              if (util.is_electron()) {
                body_2.mac_address = mac_address
              }

              let digest = 'Digest username="' + data.username + '", realm="' + realm + '", nonce="' + nonce + '", uri="' + uri + '", response="' + response + '", opaque="' + opaque + '"'
              util.log(digest)

              request
                .post(apis.login)
                .set('Authorization', digest)
                .set('Content-Type', 'application/json')
                .send(body_2)
                .end(function (err, res) {
                  if (err || !res.ok) {
                    util.log(err)
                    swal('Ups!', 'Error code ' + res.statusCode, 'warning')
                  } else {
                    util.log(res)
                    if (res.statusCode === 200) {
                      let payload = res.body
                      util.log(payload)
                      if (payload.status === 'OK') {
                        let type = payload.results.user_type
                        if (type === 'AGENT') {
                          self.remember()
                          ReactGA.event({
                            category: 'event',
                            action: config.ga.event.login,
                            label: self.state.username,
                          })
                          localdata
                            .set_login_result(payload)
                            .then((res) => {
                              setTimeout(() => {
                                history.replace('/agen')
                              }, 500)
                            })
                            .catch((err) => {
                              util.log(err)
                              if (err instanceof DOMException) {
                                util.log(err.name)
                                if (err.name === 'QuotaExceededError') {
                                  swal('Error', err.name, 'error')
                                }
                              } else {
                                if (err.message) {
                                  swal('Error', err.message, 'error')
                                }
                              }
                            })
                        } else if (type === 'MASTER') {
                          swal('Ups!', 'Anda login sebagai master agent', 'warning')
                        }
                      } else {
                        if (payload.error.code === 3007) {
                          // SMS Token
                          if (util.is_electron()) {
                            swal(res.body.error.message, res.body.display_message, 'error')
                            // swal({
                            //     title: "Error",
                            //     text: "Device ID ini belum terdaftar pada aplikasi POSFIN. Silakan kontak Master Agen Anda untuk mendaftarkannya. Apakah Anda ingin mengirim email ke Master Agen Anda?",
                            //     icon: "error",
                            //     buttons: true,
                            //     dangerMode: true,
                            // }).then((sure) => {
                            //     if (sure) {
                            //         localdata.get_property('device_id').then((device_id) => {
                            //             util.log('get property device_id: ', device_id);
                            //             const to = '';
                            //             const subject = "Aktivasi Agent Device ID";
                            //             const body = "%0A%0A%0ADevice ID: " + device_id + "%AUsername: " + self.state.username + "%AMac Address: " + mac_address;
                            //             window.open('mailto:' + to + '?subject=' + subject + '&body=' + body, 'modal');
                            //         }).catch((err) => {
                            //             util.log(err);
                            //         });
                            //     }
                            // });
                          } else {
                            self.setState({ show_sms_token: true, message_sms_token: payload.error.message })
                          }
                        } else if (payload.error.code === 3012 && util.is_electron()) {
                          swal(res.body.error.message, res.body.display_message, 'error')
                          // const error_message = res.body.display_message + '\n\n' + 'Apakah Anda ingin mengirim email ke Master Agen Anda?'
                          // swal({
                          //     title: res.body.error.message,
                          //     text: error_message,
                          //     icon: "error",
                          //     buttons: true,
                          //     dangerMode: true,
                          // }).then((sure) => {
                          //     if (sure) {
                          //         localdata.get_property('device_id').then((device_id) => {
                          //             util.log('get property device_id: ', device_id);
                          //             const to = '';
                          //             const subject = "Aktivasi Agent Device ID";
                          //             const body = "%0A%0A%0ADevice ID: " + device_id + "%0AUsername: " + self.state.username + "%0AMac Address: " + mac_address;
                          //             window.open('mailto:' + to + '?subject=' + subject + '&body=' + body, 'modal');
                          //         }).catch((err) => {
                          //             util.log(err);
                          //         });
                          //     }
                          // });
                        } else {
                          swal('Ups!', res.body.error.message, 'warning')
                        }
                      }
                    } else {
                      swal('Ups!', 'Error code ' + res.statusCode, 'warning')
                    }
                  }
                  self.setState({ login_btn: true })
                })
            } else {
              self.setState({ login_btn: true })
            }
          } else {
            if (res !== undefined) {
              swal('Ups!', 'Error code ' + res.statusCode, 'warning')
            }
            self.setState({ login_btn: true })
          }
        } else {
          if (res !== undefined) {
            util.log(res)
            swal('Ups!', res.body.error.message, 'warning')
            if (res.body.error.code === 2001) {
              self.setState({ captha_img: apis.get_captha + '?' + moment() })
            }
          } else {
            swal('Ups!', 'Error code ' + err.message, 'warning')
          }
          self.setState({ login_btn: true })
        }
      })
  }

  refresh() {
    request.get(apis.refresh_captha).end((err, res) => {
      if (err) {
        util.log('error: ' + err)
      } else {
        util.log(res)
        if (res.status === 200) {
          const data = JSON.parse(res.text)
          if (data.status === 'OK') {
            this.setState({ captha_img: apis.get_captha + '?' + moment() })
          }
        }
      }
    })
  }

  on_checkbox_change(e) {
    util.log(e.target.name + ' ' + e.target.checked)
    this.setState({ [e.target.name]: e.target.checked })
  }

  on_key_press(e) {
    if (e.keyCode === 13) {
      this.login()
    }
  }

  on_show_hide_password(e) {
    util.log('on_show_hide_password', e)
    if (this.state.type_input_password === 'password') {
      this.setState({ type_input_password: 'text' })
    } else {
      this.setState({ type_input_password: 'password' })
    }
  }

  on_btn_login_as_operator(e) {
    if (this.state.login_as === 'operator') {
      this.setState({ login_as: 'agen' })
    } else {
      this.setState({ login_as: 'operator' })
    }
  }

  render() {
    let self = this
    return (
      <div
        className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--singin m-login--2 m-login-2--skin-2"
        id="m_login"
        style={{ backgroundImage: 'url(swipe/assets/app/media/img/bg/bg-3-optimized.jpg)' }}
      >
        <div
          className="m-grid__item m-grid__item--fluid m-login__wrapper"
          style={{ padding: '3.2% 2rem 1rem 2rem' }}
        >
          <div className="m-login__container">
            <div
              className="m-login__logo"
              style={{ margin: '40px auto 1.5rem auto' }}
            >
              <img
                style={{ width: 'auto', height: '120px', marginBottom: '10px', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                src={PospayLogo}
                alt=""
              />
            </div>
            <div className="m-login__signin">
              <form
                className="m-login__form m-form"
                action=""
                style={{ marginTop: '2.5rem', marginBottom: 0 }}
              >
                <div className="form-group m-form__group">
                  <input
                    value={this.state.username}
                    onChange={(e) => this.onChange(e)}
                    className="form-control m-input"
                    type="text"
                    placeholder="Nomor Telepon (start with 62xxx) / Kode Agen"
                    name="username"
                    autoComplete="off"
                  />
                </div>
                {this.state.login_as !== 'operator' ? (
                  <div className="form-group m-form__group">
                    <input
                      value={this.state.operator}
                      onChange={(e) => this.onChange(e)}
                      className="form-control m-input"
                      type="text"
                      placeholder="Kode Operator"
                      name="operator"
                      autoComplete="off"
                    />
                  </div>
                ) : (
                  ''
                )}
                <div className="form-group m-form__group">
                  <div className="m-input-icon m-input-icon--right">
                    <input
                      value={this.state.password}
                      onChange={(e) => this.onChange(e)}
                      className="form-control m-input m-login__form-input--last"
                      type={this.state.type_input_password}
                      placeholder="Password"
                      name="password"
                    />
                    <span
                      className="m-input-icon__icon m-input-icon__icon--right"
                      style={{ width: '4rem' }}
                    >
                      <span onClick={(e) => this.on_show_hide_password(e)}>
                        <i className={this.state.type_input_password === 'password' ? 'la la-eye' : 'la la-eye-slash'}></i>
                      </span>
                    </span>
                  </div>
                </div>

                <div
                  className="form-group m-form__group row"
                  style={{ marginTop: 10 + 'px' }}
                >
                  <div className="m--align-left m-login__form-left">
                    <img
                      alt=""
                      id="captcha-img"
                      min-width="100px"
                      style={{ marginTop: 10 + 'px', marginLeft: 10 + 'px', borderRadius: '10px' }}
                      src={this.state.captha_img}
                    />
                  </div>
                  <div style={{ marginTop: 40 + 'px', marginLeft: 10 + 'px' }}>
                    <i
                      className="la la-refresh"
                      onClick={() => this.refresh()}
                    ></i>
                  </div>
                  <div
                    className="col m--align-right m-login__form-right"
                    style={{ paddingRight: 2 + 'px' }}
                  >
                    <input
                      ref={(input) => {
                        this.captha_input = input
                      }}
                      value={this.state.captha}
                      onChange={(e) => this.onChange(e)}
                      onKeyDown={this.on_key_press}
                      className="form-control m-input m-login__form-input--last"
                      type="text"
                      placeholder="Captcha"
                      name="captha"
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="row m-login__form-sub">
                  <div
                    className="col m--align-left m-login__form-left"
                    style={{ paddingLeft: 0 }}
                  >
                    <label
                      className="m-checkbox  m-checkbox--focus"
                      style={{ fontWeight: 500 }}
                    >
                      <input
                        type="checkbox"
                        name="remember"
                        onChange={this.on_checkbox_change}
                        checked={this.state.remember}
                      />
                      Simpan password ini
                      <span></span>
                    </label>
                  </div>
                  <div
                    className="col m--align-right m-login__form-right"
                    style={{ paddingRight: 0 }}
                  >
                    <a
                      onClick={() => this.on_btn_login_as_operator()}
                      className="m-link"
                      style={{ cursor: 'pointer', fontWeight: '500', color: '#aba5b6' }}
                    >
                      Login sebagai {this.state.login_as}
                    </a>
                    <NavLink
                      id="m_login_forget_password"
                      className="m-link"
                      to="/forgot-password"
                      style={{ fontWeight: 500, display: 'block' }}
                    >
                      Lupa Password
                    </NavLink>
                    <NavLink
                      id="m_login_register"
                      className="m-link"
                      to="/register-agent"
                      style={{ fontWeight: 500 }}
                    >
                      Mau Jadi Agen Kami?
                    </NavLink>
                  </div>
                </div>
                <div
                  className="m-login__form-action"
                  style={{ marginTop: 0 }}
                >
                  <button
                    style={{ backgroundColor: '#ff6900', borderColor: '#ff6900' }}
                    type="button"
                    disabled={this.state.login_btn === false}
                    onClick={() => this.login()}
                    id="m_login_signin_submit"
                    className={
                      this.state.login_btn ? 'btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn' : 'btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-loader m-loader--light m-loader--right'
                    }
                  >
                    LOGIN
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {this.state.show_sms_token ? (
          <SMSToken
            data={{
              message: this.state.message_sms_token,
              username: this.state.username,
              on_close: () => {
                self.setState({ show_sms_token: false })
              },
            }}
          />
        ) : (
          ''
        )}
        {this.state.show_name_of_user ? (
          <AgentUserName
            data={{
              on_close: () => {
                self.setState({ show_name_of_user: false })
                self.login()
              },
            }}
          />
        ) : (
          ''
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.User,
})

export default connect(mapStateToProps, null)(Login)
